<div>
    <table mat-table matSort [dataSource]="contacts" class="patient-contact-services-table">
        <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let contact">
                <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <div fxFlex="grow">
                        <app-contact-services-row [contact]="contact" [collapsed]="false"></app-contact-services-row>
                    </div>
                    <div fxFlex="10%">
                        <div class="user-info">
                            <div style="width:100px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ getCreatedDate(contact) }}</div>
                            <div style="width:100px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ getCreator(contact) }}</div>
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>